/* eslint-disable @typescript-eslint/no-explicit-any */
import type {
  IMarkupProps,
  NavigationItem,
  PartialProps,
} from '@dealerportal/common';
import parse, { type DOMNode } from 'html-react-parser';
import type { TokenValue } from 'libs/backend/src/lib/core/domain/valueObjects/TokenValue';
import { HTMLComment } from './HTMLComment';
import { reactParserOpts } from './reactOpts';

export type IncludeProps = IMarkupProps & ContentReactParserProps;
export type ContentReactParserProps = {
  children?: React.ReactElement;
  menuItems: NavigationItem[];
  partialPages: PartialProps[] | undefined;
  isMobileDevice: boolean;
  name?: string;
  className?: string;
  tokens: TokenValue[];
  cysOrigin?: string;
  wrapStylesInLayer?: string;
  bundleExternalStyles?: boolean;
  placement?: string;
  /** When true, emitted <script>/<Script> elements get a data-script-lifecycle
   *  attribute ("once" | "on-route-change") derived from content heuristics. */
  annotateScriptLifecycle?: boolean;
};

export interface Attribs {
  text: string;
  href: string;
  alt: string;
  icon: string;
  visible: string;
  u: string;
  title: string;
  src: string;
  style: string;
  class: string;
  rel: string;
  target: string;
}

export type EnhancedDOMNode = DOMNode & {
  tagName: string;
  attribs: Attribs;
  data: string;
  children: EnhancedDOMNode[];
};

export const Include: React.FC<IncludeProps> = ({
  ContentMarkup,
  HeaderMarkup,
  ...rest
}: IncludeProps) => {
  const parsedHeader = parse(
    HeaderMarkup ?? '',
    reactParserOpts({
      ...rest,
      cysOrigin: `Include ${rest.name} Header`,
      wrapStylesInLayer: 'floorforcecatalog-pagestyles',
    })
  );
  const parsedContent = parse(
    ContentMarkup ?? '',
    reactParserOpts({
      ...rest,
      cysOrigin: `Include '${rest.name}' Content`,
      wrapStylesInLayer: 'floorforcecatalog-pagestyles',
    })
  );

  return (
    <>
      <HTMLComment text={`Begin Include (${rest.name}) Header`} />
      {parsedHeader}
      <HTMLComment text={`End Include (${rest.name}) Header`} />

      <HTMLComment text={`Begin Include (${rest.name}) Content`} />
      {parsedContent}
      <HTMLComment text={`End Include (${rest.name}) Content`} />
    </>
  );
};
